import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AreaRestritaSharedModule } from '../../shared/area-restitra.shared.module';
import { SEFSaldoFinanciamentoPdf } from '../../shared/services/documentos-pdf-imprimir/financeiro/SEF/sef-saldo-financiamento-pdf';
import { PessoaService } from '../../shared/services/pessoa.service';
import { SefSaldoFinanciamentoComponent } from './sef-saldo-financiamento/sef-saldo-financiamento.component';
import { SefService } from './service/sef.service';


@NgModule({
    imports: [
        CommonModule,
        AreaRestritaSharedModule
    ],
    declarations: [
        SefSaldoFinanciamentoComponent
    ],
    providers: [
        PessoaService,
        SEFSaldoFinanciamentoPdf,
        SefService
    ]
})
export class SefModule {

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/financeiro/sef/sef.module.ts